import { BaseDto } from "src/dtos/common/baseDto";
import { CompanyDto } from "src/dtos/company/companyDto";

export interface SYS4010_R01Dto extends CompanyDto {

}

export const defaultSYS4010_R01Dto: SYS4010_R01Dto = {
  	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
	
	compCd: '',
	compNm: '',
	compNmFull: '',
	represent: '',
	regNo: '',
	telNo: '',
	faxNo: '',
	taxMobile: '',
	taxEmail: '',
	post: '',
	address: '',
	detailAddress: '',
	businessType: '',
	businessClass: '',
	moneyCd: '',
	collectTarget: '',
	paymentTarget: '',
	exceptionCollect: '',
	exceptionPayment: '',
	labelPrintAuto: '',
	apikey: '',
	remark: '',
	logoImage: '',
	signImage: '',

	inserted: false,
	isModified: false,
	
}